<template>
  <a-row :gutter="24">
    <a-col :xs="24" :md="8">
      <a-form-item>
        <template slot="label">
          Alert Threshold
          <a-tooltip placement="top">
            <template slot="title">
              <span class="fs-10">
                Minimum URL incident count required before the URL is analyzed. Default:
                {{ defaultAlertThreshold }}.
              </span>
            </template>
            <a-icon class="explain" type="info-circle" theme="filled" />
          </a-tooltip>
        </template>
        <a-input-number
          v-model="alertThresholdModel"
          :min="alertThresholdMinimum"
          :precision="0"
          size="large"
          class="full-w"
        />
      </a-form-item>
    </a-col>
    <a-col :xs="24" :md="8">
      <a-form-item>
        <template slot="label">
          Frequency threshold
          <a-tooltip placement="top">
            <template slot="title">
              <span class="fs-10">
                Minimum occurrence percentage required for a pattern to qualify for a
                suggestion. Default: {{ defaultFrequencyThreshold }}%.
              </span>
            </template>
            <a-icon class="explain" type="info-circle" theme="filled" />
          </a-tooltip>
        </template>
        <a-input-number
          v-model="frequencyThresholdModel"
          :min="frequencyThresholdMinimum"
          :max="frequencyThresholdMaximum"
          :step="1"
          :formatter="formatPercentageInput"
          :parser="parsePercentageInput"
          size="large"
          class="full-w"
        />
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script>
import {
  formatPercentageInput,
  parsePercentageInput,
  ratioToPercentage
} from '@modules/AutoFinetune/helpers/percentage';

export default {
  name: 'AutoFinetuneThresholdFields',
  props: {
    metadata: {
      type: Object,
      required: true
    },
    thresholdAlert: {
      type: Number,
      default: null
    },
    frequencyThreshold: {
      type: Number,
      default: null
    }
  },
  computed: {
    defaultAlertThreshold() {
      return this.metadata.defaults.threshold_alert;
    },
    defaultFrequencyThreshold() {
      return ratioToPercentage(this.metadata.defaults.frequency_threshold);
    },
    alertThresholdMinimum() {
      return Number(this.metadata.limits.threshold_alert.min);
    },
    frequencyThresholdMinimum() {
      const limits = this.metadata.limits.frequency_threshold_percent || {};
      return limits.min != null ? Number(limits.min) : undefined;
    },
    frequencyThresholdMaximum() {
      const limits = this.metadata.limits.frequency_threshold_percent || {};
      return limits.max != null ? Number(limits.max) : undefined;
    },
    alertThresholdModel: {
      get() {
        return this.thresholdAlert;
      },
      set(value) {
        this.$emit('update:threshold-alert', value);
      }
    },
    frequencyThresholdModel: {
      get() {
        return this.frequencyThreshold;
      },
      set(value) {
        this.$emit('update:frequency-threshold', value);
      }
    }
  },
  methods: {
    formatPercentageInput,
    parsePercentageInput
  }
};
</script>

<style lang="scss" scoped>
.full-w {
  width: 100%;
}
</style>
